<template>
  <div class="book-detail-page">
    <headers :title="{name: '图书详情'}">
      <div slot="right-sum">
        <i
          :class="book_data.is_collected ? 'collect-img-hover':'collect-img'"
          @click.stop="collect(1)"
        ></i>
        <i class="share-img" @click.stop="collect(2)"></i>
      </div>
    </headers>
    <section class="bd-info">
      <img class="cover" :src="book_data.cover_img" alt />
      <div>
        <div>
          <p class="bdi-title">{{book_data.book}}</p>
          <div class="teacher">{{book_data.author}}</div>
        </div>
        <div class="bdi-price">
          <p class="now-price">
            <icon-price v-if="book_data.price" :priceType="2"></icon-price>
            <span v-if="book_data.price">{{book_data.price | toFixPrice}}</span>
            <span v-else class="free_book">免费</span>
          </p>
          <p class="under-price" v-if="book_data.underlined_price">
            <icon-price :priceType="2"></icon-price>
            <span>{{book_data.underlined_price | toFixPrice}}</span>
          </p>
          <p class="stock">
            <font>库存</font>
            <span>{{book_data.stock}}</span>
          </p>
        </div>
      </div>
    </section>
    <group-info v-if="group_info.id" :info="group_info" comType="book_detail"></group-info>
    <active
      v-if="book_data.price || book_data.gifts_integral"
      :couponList="coupon.all"
      :detail="book_data"
      @setCoupon="setCoupon"
    ></active>
    <group v-if="group_info.id" :list="group_list" :info="group_info"></group>
    <div class="cd-tro com-style">
      <p class="cd-title">图书详情</p>
      <div class="cd-details" v-html="book_data.details"></div>
    </div>
    <div class="com-style">
      <p class="cd-title">图书评论</p>
      <commentItem></commentItem>
    </div>
    <template v-if="group_info.id">
      <p
        class="notice"
        v-if="group_info.stock - group_info.sales_num > 0"
      >拼团名额剩余{{group_info.stock - group_info.sales_num}}个，请尽快开团抢购哦</p>
      <p class="notice" v-else>拼团名额已售罄，可单独购买学习哦</p>
    </template>
    <book-share ref="share"></book-share>

    <footer-btn  v-if="group_info.id">
      <div class="btns" slot="btn">
        <div class="left-btn" @click="submit">
          <p class="p1">
            <icon-price size="mini" :priceType="2"></icon-price>
            <span>{{group_info.price | toFixPrice}}</span>
          </p>
          <p>单独购买</p>
        </div>
        <div
          class="right-btn"
          @click="openSpell"
          :class="{'default-btn': group_info.stock - group_info.sales_num == 0 && !group_info.is_join_spell}"
        >
          <p class="p1">
            <icon-price size="mini" :priceType="2"></icon-price>
            <span v-if="group_info.head_price">{{group_info.head_price | toFixPrice}}</span>
            <span v-else>{{group_info.spell_price | toFixPrice}}</span>
          </p>
          <p>{{group_info.is_join_spell ? '查看我的团':'我要开团'}}</p>
        </div>
      </div>
    </footer-btn>
    <div class="book-btn" v-else>
      <div  class="book-btn-service">
        <img src="@/assets/images/service_icon.png">
        <router-link to="/onlineService">在线客服</router-link >
      </div>
      <div class="book-btn-pay" @click="submit">立即购买</div>
    </div>
  </div>
</template>

<script>
import bookShare from "@/components/book/BookShare.vue";
import headers from "@/components/Header.vue";
import active from "@/components/book/Active.vue";
import commentItem from "@/components/CommentItem";
import group from "@/components/group/GroupList";
import groupInfo from "@/components/group/GroupInfo";
export default {
  name: "BookDetail",
  components: {
    headers,
    active,
    commentItem,
    bookShare,
    group,
    groupInfo
  },
  data() {
    return {
      id: this.$route.query.id,
      book_data: {},
      coupon: [],
      showShare: false,
      group_info: {
        id: ""
      },
      group_list: [],
      fix: false,
      active: "",
      top: 0
    };
  },
  methods: {
    /**
     * 拼团信息
     *  */
    async getGroupInfo() {
      let group_info = await this.$http.get(
        `/api/app/spellGroupInfo/${this.id}/book`
      );
      if (!Array.isArray(group_info) && group_info.res != 0) {
        let data = await this.$http.get(`/api/app/spellGroup/${group_info.id}`);
        data.list.forEach(item => {
          item.surpTime = item.end_time - Date.parse(new Date()) / 1000;
        });
        this.group_list = data.list;
        group_info.surp_time =
          group_info.end_time - Date.parse(new Date()) / 1000;
        this.group_info = group_info;
      }
    },
    async collect(type) {
      if (type == 1) {
        //   收藏
        if (this.book_data.is_collected) {
          // 取消收藏
          await this.$http.put(
            `/api/app/collect/cancel/${this.book_data.is_collected}/4`
          );
          this.$toast({
            message: "取消成功",
            duration: 800
          });
        } else {
          await this.$http.post(`/api/app/collect`, {
            book_id: this.id,
            type: 4
          });
          this.$toast({
            message: "收藏成功",
            icon: "success",
            duration: 800
          });
        }
        this.getBookDetail();
      } else {
        //   分享
        if (this.$store.state.app) {//app内分享
          this.$pub.appAction("shareImg", {
            id: `${this.id}`,
            type: 4
          });
        } else {
          this.$refs.share.showModel();
        }
      }
    },
    async getBookDetail() {
      let book_data = await this.$http.get(`/api/app/book/detail/${this.id}`);
      this.book_data = book_data;
      this.coupon = book_data.coupon;
      document.title = this.book_data.book;
      this.$store.dispatch("setShare", {
        share_type: 2,
        route: this.$route,
        web_title: this.book_data.book,
        web_description: this.book_data.instruction,
        mobile_logo: this.book_data.cover_img,
      });
    },
    setCoupon(index) {
      this.couponList[index].is_can_get = 0;
    },
    share() {
      if (this.$pub.checkLogin(true, "push")) {
        this.showShare = true;
        this.$nextTick(() => {
          this.$refs.share.showModel();
        });
      }
    },
    /**
     * 开团
     *  */
    async openSpell() {
      if (this.$pub.checkLogin(true, "push")) {
        if (this.group_info.is_join_spell) {
          // 查看我的团
          this.$router.push({
            name: "GroupDetail",
            query: {
              group_id: this.group_info.group_id
            }
          });
        } else {
          // 开团
          let flag = await this.$store.dispatch("CheckSpell", {
            spell_id: this.group_info.id
          });
          if (flag) {
            this.$router.push({
              name: "Purchase",
              query: {
                id: this.$route.query.id,
                type: 12,
                spell_id: this.group_info.id,
                group_id: 0
              }
            });
          }
        }
      }
    },
    submit() {
      if (this.$pub.checkLogin(true, "push")) {
        if (this.book_data.stock - this.book_data.sales_num <= 0) {
          this.$toast({
            message: "你来晚了哦,库存已经没有了~",
            duration: 1000
          });
        } else {
          this.$router.push({
            name: "Purchase",
            query: {
              id: this.id,
              type: 12
            }
          });
        }
      }
    }
  },
  created() {
    this.getBookDetail();
    this.getGroupInfo();
  }
};
</script>

<style lang="scss" scoped>
.book-detail-page {
  @extend %default-bg;
  padding-bottom: 125px;
  .collect-img {
    display: inline-block;
    width: 60px;
    height: 86px;
    background: url("~@/assets/images/book/collect.png") no-repeat center center;
    background-size: 36px 36px;
  }
  .collect-img-hover {
    display: inline-block;
    width: 60px;
    height: 86px;
    background: url("~@/assets/images/book/icon-star.png") no-repeat center
      center;
    background-size: 36px 36px;
  }
  .share-img {
    display: inline-block;
    width: 60px;
    height: 86px;
    background: url("~@/assets/images/book/share.png") no-repeat center center;
    background-size: 35px 35px;
  }
  .bd-info {
    background: #fff;
    display: flex;
    padding: 54px 62px;
    .cover {
      width: 206px;
      height: 288px;
      box-shadow: 0px 6px 14px 0px rgba(0, 0, 0, 0.35);
      flex: none;
    }
    > div {
      margin-left: 28px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      .bdi-title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 48px;
      }
      .teacher {
        margin-top: 20px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        line-height: 40px;
      }
      .bdi-price {
        display: flex;
        justify-content: space-between;
        /deep/ .price-ico {
          width: 16px;
          margin: 0 4px;
        }
        .now-price {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(238, 31, 31, 1);
          .free_book{
            color: #65ae58;
          }
        }
        .under-price {
          flex: 1;
          font-size: 24px;
          color: #979797;
          margin-top: 6px;
          text-decoration: line-through;
        }
        .stock {
          padding: 0 30px;
          height: 40px;
          background: rgba(242, 242, 242, 1);
          border-radius: 20px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 40px;
          text-align: center;
          font {
            color: rgba(140, 140, 140, 1);
          }
          span {
            color: #595959;
          }
        }
      }
    }
  }
  .com-style {
    margin-top: 30px;
    background: #fff;
    padding: 10px 20px;
  }
  .cd-title {
    font-size: 30px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
    padding-top: 20px;
  }
  .cd-tro {
    .cd-details {
      font-size: 28px;
      padding: 30px 10px;
      /deep/ p {
        width: 100%;
      }
      /deep/ img {
        width: 100% !important;
        display: block;
        border: none;
      }
      /deep/ video {
        width: 100%;
      }
    }
  }
  .book-btn {
    position: fixed;
    height: 88px;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #fff;
    line-height: 88px;
    font-size: 32px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    .book-btn-service{
      box-shadow: 0px 0px 7px 0px rgba(2, 108, 204, 0.06);
      width: 100%;
      text-align: center;
      a{
        color: #666666;
      }
      img{
        width: 34px;
        height: 32px;
        margin-right: 14px;
      }
    }
    .book-btn-pay{
      width: 100%;
      background: $theme_color;
      text-align: center;
      color: #fff;
    }
  }
}
/deep/ .btns {
  width: 688px;
  height: 74px;
  margin: 13px auto;
  border-radius: 37px;
  overflow: hidden;
  display: flex;
  .left-btn {
    width: 346px;
    height: 69px;
    padding-top: 5px;
    background: #ecf0ff;
    color: $theme_color;
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 32px;
      text-align: center;
    }
    .p1 {
      font-size: 26px;
    }
  }
  .right-btn {
    width: 346px;
    height: 69px;
    background: $theme_color;
    padding-top: 5px;
    color: #fff;
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 32px;
      text-align: center;
    }
    .p1 {
      font-size: 26px;
    }
  }
  .default-btn {
    color: #8c8c8c;
    background: rgba(244, 244, 244, 1);
  }
}
.notice {
  height: 54px;
  line-height: 54px;
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 0;
  background: #f4f4f4;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(140, 140, 140, 1);
  text-align: center;
}
</style>
